<template>
  <div class="menu">
    <img src="../assets/logo.png" class="logo" />
    <div class="menu-box">
      <div :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">藍圖</div>
      <div :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">
        我們
      </div>

      <!-- <div :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">核心業務</div> -->
      <div :class="step == 3 ? 'select' : ''" @click="selectMenu(3)">
        招募
      </div>
      <!-- <div :class="step == 4 ? 'select' : ''" @click="selectMenu(4)">加入團隊</div> -->
      <div :class="step == 5 ? 'select' : ''" @click="selectMenu(5)">
        聯絡我們
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Menu",
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  methods: {
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "aboutUs" });
          break;
        case 3:
          this.$router.push({ path: "offer" });
          break;
        case 4:
          this.$router.push({ path: "offers" });
          break;
        case 5:
          this.$router.push({ path: "contractUs" });
          break;
        // case 5: this.$router.push({ path: "cooperate" }); break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.menu {
  padding: 20px 360px;
  padding-right: 320px;
  display: flex;
  justify-content: space-between;
  .logo {
    width: 320px;
    height: 33px;
  }

  .menu-box {
    display: flex;
    width: 500px;
    justify-content: space-between;
    align-items: center;
    font-family: Roboto, Roboto;
    font-weight: 400;

    font-size: 18px;
    color: #333333;
    cursor: pointer;
    div {
      padding: 5px 20px;
    }
  }

  .select {
    font-weight: 500;
    color: #45289f;
  }
}
</style>
